import React from "react";

const AboutPage = () => {
  return (
    <section className="relative overflow-hidden bg-gray-50">
  {/* Animated gradient background */}
  <div className="absolute inset-0 overflow-hidden opacity-10 pointer-events-none">
    <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-blue-500/20 via-transparent to-transparent animate-pulse-slow"></div>
    <div className="absolute bottom-0 right-0 w-full h-full bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-orange-400/20 via-transparent to-transparent animate-pulse-slow animation-delay-2000"></div>
  </div>

  {/* Floating particles */}
  <div className="absolute inset-0 overflow-hidden pointer-events-none">
    {[...Array(20)].map((_, i) => (
      <div 
        key={i}
        className="absolute rounded-full bg-blue-500/10"
        style={{
          width: `${Math.random() * 10 + 2}px`,
          height: `${Math.random() * 10 + 2}px`,
          top: `${Math.random() * 100}%`,
          left: `${Math.random() * 100}%`,
          animation: `float ${Math.random() * 10 + 10}s linear infinite`,
          animationDelay: `${Math.random() * 5}s`
        }}
      ></div>
    ))}
  </div>

  <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-28 relative z-10">
    {/* Hero section with animated gradient text */}
    <div className="mb-24 group">
      <div className="w-full max-w-7xl mb-16">
        <h1 className="text-5xl sm:text-6xl md:text-7xl font-bold text-gray-900 mb-8 leading-tight">
          <span className="relative inline-block">
            <span className="relative z-10 bg-clip-text text-transparent bg-gradient-to-r from-blue-600 to-orange-500 animate-gradient-x bg-[length:200%]">
              Redefining
            </span>
          </span>{' '}
          <span className="relative inline-block mt-4">
            <span className="relative z-10">Global Commerce</span>
            <span className="absolute bottom-2 left-0 w-full h-4 bg-gradient-to-r from-blue-500/30 to-orange-400/30 rounded-full transform scale-x-105 group-hover:scale-x-110 origin-left transition-all duration-700 ease-out"></span>
          </span>
        </h1>
        <div className="w-24 h-2 bg-gradient-to-r from-blue-600 to-orange-500 rounded-full mb-8 transform group-hover:scale-x-110 origin-left transition-all duration-500"></div>
        <p className="text-xl text-gray-600 leading-relaxed max-w-2xl">
          Panagia Group delivers premium products through <span className="font-semibold bg-gradient-to-r from-blue-600 to-orange-500 bg-clip-text text-transparent">Innovative Supply Chain Solutions</span> across multiple industries worldwide.
        </p>
       
      </div>
    </div>

          {/* About section with modern cards */}
      <div className="grid lg:grid-cols-2 gap-16 items-center mb-8">
      <div className="space-y-10">
        <div>
          <span className="inline-block px-4 py-2 rounded-full bg-gradient-to-r from-blue-100 to-blue-50 text-blue-800 text-sm font-medium mb-6 border border-blue-200/50 shadow-sm">
            ABOUT US
          </span>
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-8 leading-tight">
            <span className="bg-clip-text text-transparent bg-gradient-to-r from-blue-600 to-orange-500">Redefining Excellence</span> In Global Trade
          </h2>
        </div>
        
        <div className="space-y-6 text-gray-600 leading-relaxed">
          <p className="text-sm leading-relaxed">
At Panagia group, we are redefining excellence in global trade by delivering
superior-quality products across diverse industries. Established in 2018, we
have emerged as a dynamic conglomerate with a strong foothold in
aviation trade, FMCG, personal care, luxury fragrances, and apparel
manufacturing. Our unwavering commitment to innovation, quality, and
strategic expansion has positioned us as a trusted name in both domestic
and international markets .
With an extensive manufacturing, marketing, and distribution network, we
bring world-class products under renowned brands such as Glovis, Dizee
Wash, Carefin, Wild Army, Cartor Paris, Torts, Bavarian, and Labels of Mind.
Our expertise in supply chain management, product development, and
market penetration ensures seamless business operations for our partners.
Guided by a vision for excellence, Panagia group is committed to forging
long-term, mutually beneficial partnerships with super stockists,
distributors, and retailers, driving growth and profitability across all sectors
we operate in.
          </p>
          
          <div className="grid sm:grid-cols-2 gap-6 pt-4">
            <div className="bg-gradient-to-br from-blue-50 to-white p-6 rounded-xl border border-gray-100 shadow-sm hover:shadow-md transition-shadow">
              <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center text-blue-600 mb-4">
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9"></path>
                </svg>
              </div>
              <h4 className="font-bold text-gray-800 mb-2">Global Reach</h4>
              <p className="text-gray-600 text-sm">Operating in 3+ countries </p>
            </div>
            
            <div className="bg-gradient-to-br from-orange-50 to-white p-6 rounded-xl border border-gray-100 shadow-sm hover:shadow-md transition-shadow">
              <div className="w-12 h-12 bg-orange-100 rounded-lg flex items-center justify-center text-orange-600 mb-4">
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"></path>
                </svg>
              </div>
              <h4 className="font-bold text-gray-800 mb-2">Quality Assurance</h4>
              <p className="text-gray-600 text-sm">Rigorous standards across all product lines</p>
            </div>
          </div>
        </div>
      </div>
      
      <div className="relative h-full">
        <div className="relative z-10 h-full bg-white rounded-3xl overflow-hidden shadow-2xl border border-gray-100 flex flex-col">
          <div className="bg-gradient-to-br from-blue-600 to-blue-800 p-10 text-white flex-1">
            <div className="flex items-start mb-10">
              <div className="w-14 h-14 bg-white/10 rounded-xl flex items-center justify-center mr-5 backdrop-blur-sm">
                <svg className="w-7 h-7 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 10V3L4 14h7v7l9-11h-7z"></path>
                </svg>
              </div>
              <div>
                <h3 className="text-2xl font-bold mb-1">Our Global Presence</h3>
                <p className="text-blue-200">Expanding since 2018 across continents</p>
              </div>
            </div>
            
            <div className="grid grid-cols-2 gap-6 mb-10">
              <div className="bg-white/10 rounded-xl p-6 backdrop-blur-sm border border-white/10 hover:border-white/20 transition-all">
                <div className="text-4xl font-bold mb-2 bg-clip-text text-transparent bg-gradient-to-r from-white to-blue-200">3+</div>
                <div className="text-blue-200 text-sm">Countries</div>
              </div>
              <div className="bg-white/10 rounded-xl p-6 backdrop-blur-sm border border-white/10 hover:border-white/20 transition-all">
                <div className="text-4xl font-bold mb-2 bg-clip-text text-transparent bg-gradient-to-r from-white to-blue-200">5</div>
                <div className="text-blue-200 text-sm">Core Industries</div>
              </div>
            </div>
            
            <div className="space-y-4">
              {[
                { label: "Aviation Components", scope: "Global", color: "bg-emerald-400" },
                { label: "FMCG Distribution", scope: "3 Countries", color: "bg-cyan-400" },
                { label: "Luxury Fragrances", scope: "India", color: "bg-purple-400" },
                { label: "Apparel ", scope: "3 Countries", color: "bg-amber-400" }
              ].map((item, index) => (
                <div key={index} className="flex items-center p-4 bg-white/5 rounded-lg backdrop-blur-sm border border-white/5 hover:border-white/10 transition-all">
                  <div className={`w-3 h-3 ${item.color} rounded-full mr-4 animate-pulse`}></div>
                  <span className="flex-1">{item.label}</span>
                  <span className="font-medium text-blue-100">{item.scope}</span>
                </div>
              ))}
            </div>
          </div>
          
          {/* <div className="p-8 bg-gradient-to-br from-gray-50 to-white">
            <div className="flex items-center">
              <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center text-blue-600 mr-5 shadow-sm">
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"></path>
                </svg>
              </div>
              <div>
                <h4 className="font-bold text-gray-800 text-lg">1,200+ Professionals</h4>
                <p className="text-gray-500">Dedicated team driving innovation worldwide</p>
              </div>
            </div>
          </div> */}
        </div>
        
        <div className="absolute -bottom-6 -left-6 w-40 h-40 bg-orange-400 rounded-full opacity-10 blur-3xl animate-pulse-slow"></div>
        <div className="absolute -top-6 -right-6 w-40 h-40 bg-blue-400 rounded-full opacity-10 blur-3xl animate-pulse-slow animation-delay-2000"></div>
      </div>
    </div>

  </div>

  <style jsx global>{`
    @keyframes float {
      0% { transform: translateY(0) translateX(0); }
      50% { transform: translateY(-20px) translateX(10px); }
      100% { transform: translateY(0) translateX(0); }
    }
    @keyframes pulse-slow {
      0%, 100% { opacity: 0.1; }
      50% { opacity: 0.15; }
    }
    .animate-pulse-slow {
      animation: pulse-slow 6s ease-in-out infinite;
    }
    .animation-delay-2000 {
      animation-delay: 2s;
    }
    .animate-gradient-x {
      animation: gradient-x 8s ease infinite;
      background-size: 200% 200%;
    }
    @keyframes gradient-x {
      0% { background-position: 0% 50%; }
      50% { background-position: 100% 50%; }
      100% { background-position: 0% 50%; }
    }
  `}</style>
</section>
  );
};

export default AboutPage; 